import React from "react";

const BS5_GridMedium = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridMedium Component</h2>
      <p>This is the BS5_GridMedium component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridMedium;
